import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { IconDiv, FormSelect } from '../Infos/Infos.styled'
import { FormGroup, FormInput, FormLabel } from '../../../styles/Common';
import CancelIcon from '@mui/icons-material/Cancel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TH, THead, TBody, Table, TD } from '../../../styles/Table.styled';
import { getNotyfObject, getProfilsByEtape } from '../../../shared/utility';
import TextField from '@mui/material/TextField';
import { format } from 'date-fns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { CTooltip } from '../../../components/UI/CTooltip/CTooltip';
import { fr } from 'date-fns/locale';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import { DPContainer } from '../../../containers/CampaignForm/CampaignForm.styled';
import {
    Container,
    Card,
    Row,
    Label,
    ChildContainer
} from "../InfoSteps/InfoSteps.styled";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from "@mui/material";
function InfoStepsCampagneAtestation({ steps, setSteps, userType, cannotBeModified }) {
  const notyf = getNotyfObject();
  const [open, setOpen] = useState(false);

    const addParent = () => {
        let hasEmptyElement = steps.some((item) => hasEmptyProperty(item))
        if (hasEmptyElement) {
            notyf.error("Vous ne pouvez pas ajouter un nouveau élément, Car il exsite un élément qui contient un champ vide ou null");
        } else {
            if (!cannotBeModified) {
                setSteps(prev => [
                    ...prev,
                    {
                        id: crypto.randomUUID(),
                        typeEtape: 1,
                        typeSelectionDossier: 0,
                        typeProfil: "",
                        actif: true,
                        datePrevisionnelle: "",
                        libelle: "",
                        dateStopSaisie: "",
                        children: []
                    }
                ]);
            }
        }
       
    };
    function hasEmptyProperty(obj) {

            for (let key in obj) {
              if (obj.hasOwnProperty(key) && key != "children" && key != "typeEnquete" && key !="typeSelectionDossier") {
                    if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
                        return true; // Retourne true si une propriété est vide ou null
                    }
                }
            }
            return false; // Retourne false si aucune propriété vide ou null n'est trouvée
        }

    const addChild = (i) => {
        if (!cannotBeModified) {
            const updated = [...steps];
            let hasEmptyElement = updated[i].children.some((item) => hasEmptyProperty(item)) || steps.some((item) => hasEmptyProperty(item))
            if (hasEmptyElement) {
                notyf.error("Vous ne pouvez pas ajouter un nouveau élément, Car il exsite un élément qui contient un champ vide ou null");
            } else {
                updated[i].children.push({
                    id: crypto.randomUUID(),
                    typeEtape: "",
                    actif: true,
                    typeProfil: "",
                    typeSelectionDossier:0,
                    libelle: "",
                    datePrevisionnelle: "",
                    dateStopSaisie: ""
                });
                setSteps(updated);
            }
        }
    };

    const updateParent = (i, field, value) => {
        if (!cannotBeModified) {
            if (["dateStopSaisie", "datePrevisionnelle"].includes(field)) {
                value = format(new Date(new Date(value.getTime())), 'yyyy-MM-dd')
            }
            if (["typeEtape", "typeProfil"].includes(field)) {
                value = parseInt(value, 10)
            }


            const updated = [...steps];
            updated[i][field] = value;
            setSteps(updated);
        }
    };

    const updateChild = (i, j, field, value) => {
        if (!cannotBeModified) {
            if (["dateStopSaisie", "datePrevisionnelle"].includes(field)) {
                value = format(new Date(new Date(value.getTime())), 'yyyy-MM-dd')
            }
          if (["typeEtape", "typeProfil","typeSelectionDossier"].includes(field)) {
                value = parseInt(value, 10)
            }
            if (field === "typeEtape" && value === "1") return;

            const updated = [...steps];
            updated[i].children[j][field] = value;
            setSteps(updated);
        }
    };

    const deleteParent = (i) => {
        if (!cannotBeModified) {
            const updated = [...steps];
            updated.splice(i, 1);
            setSteps(updated);
        }
    };

    const deleteChild = (i, j) => {
        if (!cannotBeModified) {
            const updated = [...steps];
            updated[i].children.splice(j, 1);
            setSteps(updated);
        }
    };

    return (
      <div>
        <Accordion expanded={open} onChange={() => setOpen(!open)}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ fontSize: "xx-large" }} />}
          >
            <Typography>
              Étapes de la campagne
            </Typography>

              <FontAwesomeIcon
                icon={faCirclePlus}
                style={{
                  marginLeft: "15px",
                  color: "#2174b980",
                  fontSize: "1.25rem",
                  cursor: "pointer"
                }}
              onClick={(e) => {
                e.stopPropagation(); // important pour éviter toggle accordion
                  addParent();
                }}
              />
          
          </AccordionSummary>

          <AccordionDetails>
        {
          steps?.map((parent, i) => (
                <Card key={parent.id}>       
                    <Table style={{ marginBottom: "10px" }}>
                        <THead>
                                <tr style={{ width: "100%", display: "flex", justifyContent: "space-between", paddingTop: "5px" }}>
                                    <TH style={{ width: "45px", background: '#FFF', color: "#FFF", paddingLeft: "2px" }}></TH>
                                    <TH style={{ width: "calc((100% - 46px) * 0.14)", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Etape</TH>
                                    <TH style={{ width: "calc((100% - 46px) * 0.11)", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Type selection</TH>
                                    <TH style={{ width: "calc((100% - 46px) * 0.17)", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Libelle</TH>
                                    <TH style={{ width: "calc((100% - 46px) * 0.16)", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Date de fin de saisie </TH>
                                    <TH style={{ width: "calc((100% - 46px) * 0.15)", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Date d'envoi </TH>
                                    <TH style={{ width: "calc((100% - 46px) * 0.17)", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Profile Communication </TH>                    
                                    <TH style={{ width: "calc((100% - 46px) * 0.10)", background: '#8392AB', color: "#F1F4F9", paddingLeft: "8px" }}>Action </TH>   
                                </tr>
                            </THead>
                        </Table>
                    <Row>                     
                        <Label >Type :</Label>
                                               
                        <TD style={{ width: "calc((100% - 45px) * 0.14)" }}>
                            <FormGroup bd={"#000"} style={{ paddingTop: "1px" }}>
                                <strong>Envoi initial</strong>
                            </FormGroup>
                        </TD>


                        <TD style={{ width: "calc((100% - 46px) * 0.11)" }}>
                            <FormGroup bd={"#000"} style={{ paddingTop: "0px" }}>
                                <FormSelect
                                  style={{ textAlign: "start" }}
                                  disabled={parent.typeEtape == '1'}
                                  name="typeSelectionDossier"
                                  value={parent?.typeSelectionDossier ?? 0}
                                  onChange={(e) => updateParent(i, 'typeSelectionDossier', e.target.value)}
                                >
                                  <option value="0">Global</option>
                                  <option value="1">Non répondu</option>
                                  <option value="2">Incomplet</option>
                                  <option value="3">Non rép./Incomplet</option>

                                </FormSelect>
                            </FormGroup>
                        </TD>

                        <TD style={{ width: "calc((100% - 45px) * 0.17)" }}>
                            <FormGroup bd={"#000"}>
                                <FormInput style={{ width: "130px" ,textAlign: "start" }}
                                    id="Libelle"
                                    type="texte"
                                    disabled={!parent.actif}
                                    placeHolder="Envoi initial mars"
                                    value={parent?.libelle || ""}
                                    onChange={e => updateParent(i, "libelle", e.target.value)}
                                    maxLength={255}

                                />
                            </FormGroup>
                        </TD>
               
                        <TD style={{ width: "calc((100% - 45px) * 0.16)", paddingTop: "5px" }}>
                            <FormGroup bd={"#fff"} >
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                                    <DPContainer>
                                        <DatePicker
                                            id="date-picker-dialog"
                                            label="Date stop saisie"
                                            format="dd/MM/yyyy"
                                            readOnly={cannotBeModified}
                                            disabled={!parent.actif}
                                            // minDate={currentDate}
                                            value={new Date(parent?.dateStopSaisie)}
                                            onChange={(e) => updateParent(i, "dateStopSaisie", e)}
                                            // onChange={handleOuvertureOpsDateChange}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            // minDate={generateMinEndDate(index)}
                                            invalidDateMessage="Format de date invalide"
                                            maxDateMessage="La date ne doit pas être postérieure à la date maximale"
                                            minDateMessage="La date ne doit pas être antérieure à la date minimale"
                                            renderInput={(params) => <TextField {...params} />}
                                        // open={true} control open dialog state
                                        />
                                    </DPContainer>

                                </LocalizationProvider>
                            </FormGroup>
                        </TD>

                        <TD style={{ width: "calc((100% - 45px) * 0.15)", paddingTop: "5px" }}>
                            <FormGroup bd={"#fff"} >
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                                    <DPContainer>
                                        <DatePicker
                                            id="date-picker-dialog"
                                            label="Date d'envoi"
                                            format="dd/MM/yyyy"
                                            readOnly={cannotBeModified}
                                            // minDate={currentDate}
                                            disabled={!parent.actif || (parent.dateStopSaisie == "")}
                                            value={new Date(parent?.datePrevisionnelle)}
                                            onChange={(e) => updateParent(i, "datePrevisionnelle", e)}
                                            // onChange={handleOuvertureOpsDateChange}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            minDate={new Date(parent.dateStopSaisie)}
                                            invalidDateMessage="Format de date invalide"
                                            maxDateMessage="La date ne doit pas être postérieure à la date maximale"
                                            minDateMessage="La date ne doit pas être antérieure à la date minimale"
                                            renderInput={(params) => <TextField {...params} />}
                                        // open={true} control open dialog state
                                        />
                                    </DPContainer>

                                </LocalizationProvider>
                            </FormGroup>
                        </TD>

                        <TD style={{ width: "calc((100% - 45px) * 0.17)" }}>
                            <FormGroup bd={"#000"} style={{ paddingTop: "1px" }}>
                                <FormSelect
                                    style={{textAlign: "start"}}
                                    id="countryCode"
                                    name="typeProfil"
                                    disabled={!parent.actif}
                                    value={parent?.typeProfil || ""}
                                    onChange={(e) => updateParent(i, "typeProfil", e.target.value)}
                                >
                                    <option >Choisir un profile</option>
                                    
                                    {getProfilsByEtape(1).map((item, index) => (
                                        <option key={index} value={item?.value}>
                                            {item?.label}
                                        </option>
                                    ))}
                                  
                                </FormSelect>
                            </FormGroup>
                        </TD>

                        <TD style={{ width: "calc((100% - 45px) * 0.08)", display: "flex", alignItems: "center" }}>
                            {!cannotBeModified && parent.actif && <CancelIcon onClick={(e) => deleteParent(i)} style={{ color: "#EE5A5A", cursor: "pointer", fontSize: "30px" }} />}
                            <IconDiv>
                                <CTooltip title={"➕ Ajouter Relance / MED)"} className="tableActions__icon">
                                    <FontAwesomeIcon icon={faCirclePlus}
                                        style={{ display: cannotBeModified ? "none" : "flex", color: "#2174b980", fontSize: "25px" }}
                                        onClick={e => addChild(i)} />
                                </CTooltip>

                            </IconDiv>
                        </TD>
                    </Row>

                    {/* children */}
                    <ChildContainer>
                        {parent?.children?.map((child, j) => (
                            <Row key={child.id}>
                              
                                <TD style={{ width: "14%" }}>
                              <FormGroup bd={"#000"} style={{ paddingTop: "1px"}}>
                                        <FormSelect
                                            style={{ textAlign: "start" }}
                                            id="countryCode"
                                            name="typeEtape"
                                            value={child.typeEtape}
                                            disabled={!child.actif}
                                            onChange={(e) => updateChild(i, j, "typeEtape", e.target.value)}
                                        >
                                            <option value="">Choisir une etape</option>
                                            <option value="2">Relance</option>
                                            <option value="3">Mise en demeure</option>
                                        </FormSelect>
                                    </FormGroup>
                                </TD>

                            <TD style={{ width: "11%" }}>
                              <FormGroup bd={"#000"} style={{ paddingTop: "0px" }}>
                                <FormSelect
                                  style={{ textAlign: "start" }}
                                  disabled={!child.actif}
                                  name="typeSelectionDossier"
                                  value={child?.typeSelectionDossier ?? 0}
                                  onChange={(e) => updateChild(i,j, 'typeSelectionDossier', e.target.value)}
                                >
                                  <option value="0">Global</option>
                                  <option value="1">Non répondu</option>
                                  <option value="2">Incomplet</option>
                                  <option value="3">Non rép./Incomplet</option>

                                </FormSelect>
                              </FormGroup>
                            </TD>
                                <TD style={{ width: "17%" }}>
                                    <FormGroup>
                                        <FormInput
                                            style={{ width: "130px", textAlign: "start" }}
                                            id="Libelle"
                                            type="texte"
                                            disabled={!child.actif}
                                            placeHolder="Relance mars"
                                            value={child?.libelle || ""}
                                            onChange={e => updateChild(i, j, "libelle", e.target.value)}
                                            maxLength={255}

                                        />
                                    </FormGroup>
                                </TD>                

                                <TD style={{ width: "16%", paddingTop: "5px" }}>
                                    <FormGroup bd={"#fff"} >
                                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                                            <DPContainer>
                                                <DatePicker
                                                    id="date-picker-dialog"
                                                    label="Date stop saisie"
                                                    format="dd/MM/yyyy"
                                                    readOnly={cannotBeModified}
                                                    disabled={!child.actif}
                                                    // minDate={currentDate}
                                                    value={new Date(child?.dateStopSaisie)}

                                                    onChange={(e) => updateChild(i, j, "dateStopSaisie", e)}
                                                    // onChange={handleOuvertureOpsDateChange}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    minDate={new Date(parent?.datePrevisionnelle)}
                                                    invalidDateMessage="Format de date invalide"
                                                    maxDateMessage="La date ne doit pas être postérieure à la date maximale"
                                                    minDateMessage="La date ne doit pas être antérieure à la date minimale"
                                                    renderInput={(params) => <TextField {...params} />}
                                                // open={true} control open dialog state
                                                />
                                            </DPContainer>

                                        </LocalizationProvider>
                                    </FormGroup>
                                </TD>

                                <TD style={{ width: "15%", paddingTop: "5px" }}>
                                    <FormGroup bd={"#fff"} >
                                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                                            <DPContainer>
                                                <DatePicker
                                                    id="date-picker-dialog"
                                                    label="Date d'envoi"
                                                    format="dd/MM/yyyy"
                                                    readOnly={cannotBeModified}
                                                    disabled={!child.actif || (child.dateStopSaisie == "")}
                                                    // minDate={currentDate}
                                                    value={new Date(child?.datePrevisionnelle)}
                                                    onChange={(e) => updateChild(i, j, "datePrevisionnelle", e)}
                                                    // onChange={handleOuvertureOpsDateChange}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    minDate={new Date(child.dateStopSaisie)}
                                                    invalidDateMessage="Format de date invalide"
                                                    maxDateMessage="La date ne doit pas être postérieure à la date maximale"
                                                    minDateMessage="La date ne doit pas être antérieure à la date minimale"
                                                    renderInput={(params) => <TextField {...params} />}
                                                // open={true} control open dialog state
                                                />
                                            </DPContainer>

                                        </LocalizationProvider>
                                    </FormGroup>
                                </TD>

                                <TD style={{ width: "17%" }}>
                                    <FormGroup bd={"#000"} style={{ paddingTop: "1px" }}>
                                        <FormSelect
                                            style={{ textAlign: "start",width:"100%" }}
                                            id="countryCode"
                                            name="typeProfil"
                                            value={child?.typeProfil || ""}
                                            disabled={!child.actif}
                                            onChange={(e) => updateChild(i, j, "typeProfil", e.target.value)}
                                        >
                                            <option >Choisir un profile</option>
                                            {getProfilsByEtape(child.typeEtape).map((item, index) => (
                                                <option key={index} value={item?.value}>
                                                    {item?.label}
                                                </option>
                                            ))}
                                           
                                        </FormSelect>
                                    </FormGroup>
                                </TD>

                                <TD style={{ width: "8%" }}>
                                    {!cannotBeModified && child.actif && <CancelIcon onClick={(e) => deleteChild(i, j)} style={{ color: "#EE5A5A", cursor: "pointer", fontSize: "20px" }} />}
                                </TD>

                            </Row>
                        ))}
                    </ChildContainer>
                </Card>
          ))}
          </AccordionDetails>
        </Accordion>
        </div>
    );
}

export default InfoStepsCampagneAtestation;
